import React, { type FC } from "react";

import "./disabled.css";
import AICHeader from "src/components/AICLayout/AICHeader/AICHeader";
import { useTranslation } from "react-i18next";

const CountryDisabled: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <AICHeader disableCountryChange />
      <div className="disabled-page">
        <h1 className="disabled-text">{t("aic_disabled_marketplace_text")}</h1>
      </div>
    </div>
  );
};

export default CountryDisabled;
